import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

const GroupedCardItem = ({ icon , header , content , url , urlText  })=>{
    return /*#__PURE__*/ React.createElement(Card, {
        className: "grouped-cards__card"
    }, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true
    }, /*#__PURE__*/ React.createElement(Card.Icon, {
        name: icon,
        height: 24,
        width: 24
    }), /*#__PURE__*/ React.createElement(Heading, {
        id: header,
        component: "h3",
        variant: "subheading2"
    }, header)), /*#__PURE__*/ React.createElement(Card.Section, {
        spacing: "m"
    }, content), url && urlText && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Link, {
        href: url
    }, urlText, " ", /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    })))));
};

export { GroupedCardItem, GroupedCardItem as default };
//# sourceMappingURL=GroupedCardItem.js.map
